import type { EventCode, EventListItem, EventSeverity, EventView, Paginated } from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

/** Couche réseau de l'écran Journal (`02` §11). */

export interface JournalListParams {
  page: number;
  pageSize: number;
  sortDir: 'asc' | 'desc';
  sortBy?: string;
  view: EventView;
  technical?: boolean;
  severity?: EventSeverity[];
  code?: EventCode[];
  origin?: string[];
  search?: string;
  from?: string;
  to?: string;
}

/**
 * `GET /api/events` — un seul endpoint pour les deux onglets, distingués par
 * `view` (voir `apps/server/src/http/api/events/list.ts`).
 */
export function fetchJournalList(params: JournalListParams): Promise<Paginated<EventListItem>> {
  return apiFetch<Paginated<EventListItem>>('/api/events', {
    query: {
      page: params.page,
      pageSize: params.pageSize,
      sortDir: params.sortDir,
      view: params.view,
      ...(params.sortBy ? { sortBy: params.sortBy } : {}),
      ...(params.technical === true ? { technical: true } : {}),
      ...(params.severity && params.severity.length > 0 ? { severity: params.severity } : {}),
      ...(params.code && params.code.length > 0 ? { code: params.code } : {}),
      ...(params.origin && params.origin.length > 0 ? { origin: params.origin } : {}),
      ...(params.search ? { search: params.search } : {}),
      ...(params.from ? { from: params.from } : {}),
      ...(params.to ? { to: params.to } : {}),
    },
  });
}
